import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { Menu } from 'lucide-react';

export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-[#F0F4FF]">
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div className="fixed inset-0 bg-black/50 z-20 lg:hidden" onClick={() => setSidebarOpen(false)} />
      )}

      {/* Sidebar */}
      <div className={`fixed inset-y-0 left-0 z-30 transform transition-transform duration-300 lg:translate-x-0 ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}>
        <Sidebar onClose={() => setSidebarOpen(false)} />
      </div>

      {/* Main content */}
      <div className="flex-1 flex flex-col min-w-0 lg:ml-64">
        {/* Mobile header */}
        <div className="lg:hidden flex items-center h-14 px-4 border-b border-blue-100"
          style={{ background: 'linear-gradient(90deg, #0147a0, #003375)' }}>
          <button onClick={() => setSidebarOpen(true)} className="p-2 rounded-lg text-white/70 hover:bg-white/10" data-testid="mobile-menu-btn">
            <Menu className="w-5 h-5 text-white" />
          </button>
          <span className="ml-3 font-bold text-white text-sm" style={{ fontFamily: 'Manrope, sans-serif' }}>Gugu Turismo</span>
        </div>

        <main className="flex-1 p-4 sm:p-6 lg:p-8 page-enter">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
